module.exports = __webpack_public_path__ + "static/img/bg-tr.9f2eb172.png";